// extracted by mini-css-extract-plugin
export default {"subscription_page_v2":"Ma","subscription_page_v2_row":"Na","subscription_page_row":"Oa","order_summary_wrapper":"Pa","loading_wrapper":"Qa","snooze_order_button":"Ra","buttons_wrapper":"Sa","retake_quiz":"Ta"};
    if(module.hot) {
      // 1738064233262
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  